import { isMobile } from '~/genericFunctions';

export const isButtonVisible = (ismobile) => !isMobile(ismobile);
